export default __webpack_public_path__ + "static/media/commission_girl_boy.c2e1ba02.png";